export default "__VITE_ASSET__DKynvZCd__"